import axios from 'axios';
import { buildApiUrl } from '../utils/apiUrl';

/**
 * Innlogget utkast — cookies via global axios-interceptor.
 * @returns {Promise<{ draft: null | { id: string, data: object, savedAt: string } }>}
 */
export async function fetchMyDraft(config) {
	const { data } = await axios.get(buildApiUrl('form/draft/me'), config);
	return data;
}

export async function saveMyDraft(formData, config) {
	const { data } = await axios.put(
		buildApiUrl('form/draft/me'),
		{ formData },
		config
	);
	return data;
}

export async function deleteMyDraft(config) {
	const { data } = await axios.delete(buildApiUrl('form/draft/me'), config);
	return data;
}
